"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
class BlankMapper {
    map(fromOrList) {
        return fromOrList;
    }
}
exports.BlankMapper = BlankMapper;
class ClosureMapper {
    constructor(closure) {
        this.closure = closure;
    }
    map(fromOrList) {
        if (fromOrList instanceof Array) {
            return fromOrList.map(from => this.closure(from));
        }
        return this.closure(fromOrList);
    }
}
exports.ClosureMapper = ClosureMapper;
class CastMapper {
    map(fromOrList) {
        try {
            if (fromOrList instanceof Array) {
                return fromOrList.map(from => from);
            }
            return fromOrList;
        }
        catch (e) {
            throw new Error('CastMapper failed to map an object)');
        }
    }
}
exports.CastMapper = CastMapper;
class ObjectMapper {
    map(fromOrList) {
        if (fromOrList === null || typeof fromOrList === 'undefined') {
            return;
        }
        try {
            if (fromOrList instanceof Array) {
                return fromOrList.map(from => Object.assign({}, from));
            }
            return Object.assign({}, fromOrList);
        }
        catch (e) {
            throw new Error('ObjectMapper failed to map an object)');
        }
    }
}
exports.ObjectMapper = ObjectMapper;
class ClassTransformerMapper {
    constructor(toType) {
        this.toType = toType;
    }
    map(fromOrList) {
        try {
            return class_transformer_1.plainToClass(this.toType, fromOrList);
        }
        catch (e) {
            throw new Error('ClassTransformerMapper failed to map an object)');
        }
    }
}
exports.ClassTransformerMapper = ClassTransformerMapper;
class JsonSerializerMapper {
    map(fromOrList) {
        if (fromOrList instanceof Array) {
            return fromOrList.map(from => JSON.stringify(from));
        }
        return JSON.stringify(fromOrList);
    }
}
exports.JsonSerializerMapper = JsonSerializerMapper;
class JsonDeserializerMapper {
    constructor(toType) {
        this.toType = toType;
    }
    map(fromOrList) {
        if (!fromOrList) {
            throw new Error('JsonDeserializerMapper cannot map an empty input)');
        }
        try {
            if (fromOrList instanceof Array) {
                return fromOrList.map((from) => this.deserialize(from));
            }
            if (typeof fromOrList === 'string') {
                fromOrList = JSON.parse(fromOrList);
            }
            return this.deserialize(fromOrList);
        }
        catch (e) {
            throw new Error('JsonDeserializerMapper failed to map an object)');
        }
    }
    deserialize(from) {
        const output = new this.toType();
        let properties = Object.keys(from);
        properties.forEach((property) => {
            output[property] = from[property];
        });
        return output;
    }
}
exports.JsonDeserializerMapper = JsonDeserializerMapper;
